import {getConfigItem, configConstants} from '@servicenow/ui-config';
import createQueryBatcher from './createQueryBatcher';

const {DISABLE_GQL_BATCHING} = configConstants;
const batchingEnabled = !getConfigItem(DISABLE_GQL_BATCHING);

const batcher = createQueryBatcher({
	batchingEnabled
});

export default function sendRequest(
	operationName = '',
	variables = {},
	templateVars = {},
	domainContext = {},
	headers = {},
	transactionMetaData,
	queryContext
) {
	const operation = {
		variables,
		templateVars,
		domainContext,
		headers,
		operationName,
		transactionMetaData,
		queryContext
	};

	return batcher.enqueue(operation);
}
